import { DefaultService } from '@/services/DefaultService';

export default class GrupoProdutoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(cliente) {
        return this._http.post(`${this._env}/promotor/produto/grupo`, cliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id) {
        return this._http.get(`${this._env}/promotor/produto/grupo/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/promotor/produto/grupo/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    changeSituacao(grupo) {
        return this._http.post(`${this._env}/product/grupoproduto/updatesituacao`, grupo, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllNaoVinculadoRegraDesconto(page, limit, sort, idvenpoliticadesconto, ...params) {
        return this._http.get(encodeURI(`${this._env}/product/group/findAllNaoVinculadoRegraDesconto.json?page=${page}&limit=${limit}&column=${sort.column}&order=${sort.order}&idvenpoliticadesconto=${idvenpoliticadesconto}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(page, limit, sort, situacao = 2, idempresa, ...params) {
        return this._http.get(encodeURI(`${this._env}/promotor/produto/grupo.json?page=${page}&limit=${limit}&column=${sort.column}&order=${sort.order}&situacao=${situacao}&idempresa=${idempresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllCombo(...params) {
        return this._http.get(encodeURI(`${this._env}/product/getcombo/group.json?param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    // @84563 - Obter o combo de pesquisa com base nas empresas associadas
    findAllComboWithEmpresa(idempresa, ...params) {
        return this._http.get(encodeURI(`${this._env}/product/getcombowithcompany/group.json?idempresa=${idempresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}